var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 840,
    height: 840,
    viewBox: "0 0 840 840",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93 81C84.1634 81 77 88.1634 77 97V321C77 329.837 84.1635 337 93 337H312.419L377.646 499.946C358.343 512.629 345.595 534.498 345.595 559.35C345.595 592.053 367.671 619.592 397.709 627.83V629.503C397.709 639.286 393.829 648.669 386.923 655.587L374.691 667.84C349.697 692.875 349.697 733.465 374.691 758.5C399.684 783.535 440.206 783.535 465.2 758.5L470.411 753.28C492.526 731.128 492.526 695.212 470.411 673.06L438.965 704.558C443.713 709.315 443.713 717.026 438.965 721.782L433.754 727.002C426.127 734.641 413.763 734.641 406.136 727.002C398.51 719.363 398.51 706.977 406.136 699.338L418.369 687.086C433.615 671.814 442.181 651.101 442.181 629.503V625.529C468.614 615.218 487.346 589.475 487.346 559.35C487.346 534.709 474.814 513 455.785 500.27L522.187 337H531.555L533.207 341.904L531.676 337H748C756.837 337 764 329.837 764 321V97C764 88.1634 756.837 81 748 81H93ZM365.888 337H468.611L416.841 464.289L365.888 337Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNull);
export default __webpack_public_path__ + "static/media/null.a12a93228a844637bdd32438e19d5ae1.svg";
export { ForwardRef as ReactComponent };